import { Input } from "@/components/ui/input";
import React, { useState } from "react";
import { LuChevronRight, LuSearch } from "react-icons/lu";

interface LinkItem {
  href: string;
  text: string;
}

const ListProdi: React.FC = () => {
  const [filter, setFilter] = useState("");

  const links: LinkItem[] = [
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/d3-desain-komunikasi-visual/",
      text: "Diploma Tiga (D3) - Desain Komunikasi Visual",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/kebidanan/",
      text: "Diploma Tiga (D3) - Kebidanan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/d3-perpustakaan/",
      text: "Diploma Tiga (D3) - Perpustakaan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/d4-trpl/",
      text: "Sarjana Terapan (D4) - Teknologi Rekayasa Perangkat Lunak",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/d4-trse/",
      text: "Sarjana Terapan (D4) - Teknologi Rekayasa Sistem Elektronika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/d4-kimia-terapan/",
      text: "Sarjana Terapan (D4) - Kimia Terapan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/d4-bioteknologi-perikanan/",
      text: "Sarjana Terapan (D4) - Bioteknologi Perikanan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/d4-trpj/",
      text: "Sarjana Terapan (D4) - Teknologi Rekayasa Penginderaan Jauh",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ekonomi/d4-pengelolaan-perhotelan/",
      text: "Sarjana Terapan (D4) - Pengelolaan Perhotelan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ekonomi/d4-akuntansi-sektor-publik/",
      text: "Sarjana Terapan (D4) - Akuntansi Sektor Publik",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/d4-bikspro/",
      text: "Sarjana Terapan (D4) - Bahasa Inggris untuk Komunikasi Bisnis dan Profesional",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/pendidikan-teknik-informatika/",
      text: "Sarjana (S1) - Pendidikan Teknik Informatika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/pendidikan-kesejahteraan-keluarga/",
      text: "Sarjana (S1) - Pendidikan Kesejahteraan Keluarga",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/pendidikan-teknik-elektro/",
      text: "Sarjana (S1) - Pendidikan Teknik Elektro",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/pendidikan-teknik-mesin/",
      text: "Sarjana (S1) - Pendidikan Teknik Mesin",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/sistem-informasi/",
      text: "Sarjana (S1) - Sistem Informasi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/ilmu-komputer/",
      text: "Sarjana (S1) - Ilmu Komputer",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-teknik-dan-kejuruan/pendidikan-vokasional-seni-kuliner/",
      text: "Sarjana (S1) - Pendidikan Vokasional Seni Kuliner",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/pendidikan-bahasa-dan-sastra-indonesia/",
      text: "Sarjana (S1) - Pendidikan Bahasa dan Sastra Indonesia",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/pendidikan-bahasa-inggris/",
      text: "Sarjana (S1) - Pendidikan Bahasa Inggris",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/pendidikan-seni-rupa/",
      text: "Sarjana (S1) - Pendidikan Seni Rupa",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/pendidikan-bahasa-bali/",
      text: "Sarjana (S1) - Pendidikan Bahasa Bali",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-bahasa-dan-seni/pendidikan-bahasa-jepang/",
      text: "Sarjana (S1) - Pendidikan Bahasa Jepang",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ekonomi/pendidikan-ekonomi/",
      text: "Sarjana (S1) - Pendidikan Ekonomi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ekonomi/manajemen/",
      text: "Sarjana (S1) - Manajemen",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ekonomi/akuntansi/",
      text: "Sarjana (S1) - Akuntansi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/pendidikan-matematika/",
      text: "Sarjana (S1) - Pendidikan Matematika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/matematika/",
      text: "Sarjana (S1) - Matematika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/pendidikan-fisika/",
      text: "Sarjana (S1) - Pendidikan Fisika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/fisika",
      text: "Sarjana (S1) - Fisika",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/kimia/",
      text: "Sarjana (S1) - Kimia",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/pendidikan-kimia/",
      text: "Sarjana (S1) - Pendidikan Kimia",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/pendidikan-biologi/",
      text: "Sarjana (S1) - Pendidikan Biologi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/biologi/",
      text: "Sarjana (S1) - Biologi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/pendidikan-ipa/",
      text: "Sarjana (S1) - Pendidikan IPA",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-matematika-dan-ilmu-pengetahuan-alam/akuakultur/",
      text: "Sarjana (S1) - Akuakultur",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/pendidikan-geografi/",
      text: "Sarjana (S1) - Pendidikan Geografi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/geografi/",
      text: "Sarjana (S1) - Geografi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/pendidikan-sejarah/",
      text: "Sarjana (S1) - Pendidikan Sejarah",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/pendidikan-pancasila-dan-kewarganegaraan/",
      text: "Sarjana (S1) - Pendidikan Pancasila dan Kewarganegaraan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/pendidikan-sosiologi/",
      text: "Sarjana (S1) - Pendidikan Sosiologi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-hukum-dan-ilmu-sosial/ilmu-hukum/",
      text: "Sarjana (S1) - Ilmu Hukum",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ilmu-pendidikan/bimbingan-dan-konseling/",
      text: "Sarjana (S1) - Bimbingan dan Konseling",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ilmu-pendidikan/teknologi-pendidikan/",
      text: "Sarjana (S1) - Teknologi Pendidikan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ilmu-pendidikan/pendidikan-guru-sekolah-dasar/",
      text: "Sarjana (S1) - Pendidikan Guru Sekolah Dasar",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-ilmu-pendidikan/pendidikan-guru-pendidikan-anak-usia-dini/",
      text: "Sarjana (S1) - Pendidikan Guru Pendidikan Anak Usia Dini",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-olahraga-dan-kesehatan/pendidikan-kepelatihan-olahraga/",
      text: "Sarjana (S1) - Pendidikan Kepelatihan Olahraga",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-olahraga-dan-kesehatan/pendidikan-jasmani-kesehatan-dan-rekreasi/",
      text: "Sarjana (S1) - Pendidikan Jasmani Kesehatan dan Rekreasi",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-olahraga-dan-kesehatan/ilmu-keolahragaan/",
      text: "Sarjana (S1) - Ilmu Keolahragaan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/program-studi-kedokteran/",
      text: "Sarjana (S1) - Kedokteran",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/keperawatan/",
      text: "Sarjana (S1) - Keperawatan",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/program-studi-s1-kebidanan/",
      text: "Sarjana (S1) - Kebidanan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-administrasi-pendidikan/",
      text: "Magister (S2) - Administrasi Pendidikan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-akuntansi/",
      text: "Magister (S2) - Akuntansi",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-bimbingan-dan-konseling/",
      text: "Magister (S2) - Bimbingan dan Konseling",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-ilmu-komputer/",
      text: "Magister (S2) - Ilmu Komputer",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-ilmu-manajemen/",
      text: "Magister (S2) - Ilmu Manajemen",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-bahasa/",
      text: "Magister (S2) - Pendidikan Bahasa",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-bahasa-inggris/",
      text: "Magister (S2) - Pendidikan Bahasa Inggris",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-dasar/",
      text: "Magister (S2) - Pendidikan Dasar",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-ips/",
      text: "Magister (S2) - Pendidikan IPS",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-olahraga/",
      text: "Magister (S2) - Pendidikan Olahraga",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-teknologi-pendidikan/",
      text: "Magister (S2) - Teknologi Pendidikan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-matematika/",
      text: "Magister (S2) - Pendidikan Matematika",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-ipa/",
      text: "Magister (S2) - Pendidikan IPA",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-kimia/",
      text: "Magister (S2) - Pendidikan Kimia",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-penelitian-dan-evaluasi-pendidikan/",
      text: "Magister (S2) - Penelitian dan Evaluasi Pendidikan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-manajemen-lingkungan/",
      text: "Magister (S2) - Manajemen Lingkungan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/magister-pendidikan-anak-usia-dini/",
      text: "Magister (S2) - Pendidikan Anak Usia Dini",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/doktor-pendidikan-dasar/",
      text: "Doktor (S3) - Pendidikan Dasar",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/doktor-ilmu-pendidikan/",
      text: "Doktor (S3) - Ilmu Pendidikan",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/doktor-pendidikan-bahasa/",
      text: "Doktor (S3) - Pendidikan Bahasa",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/doktor-pendidikan-bahasa-inggris/",
      text: "Doktor (S3) - Pendidikan Bahasa Inggris",
    },
    {
      href: "https://undiksha.ac.id/akademik/program/pascasarjana/doktor-teknologi-pendidikan/",
      text: "Doktor (S3) - Teknologi Pendididikan",
    },
    {
      href: "http://ppg.undiksha.ac.id",
      text: "Profesi - Pendidikan Profesi Guru",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/profesi-dokter/",
      text: "Profesi - Pendidikan Profesi Dokter",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/profesi-ners/",
      text: "Profesi - Pendidikan Profesi Ners",
    },
    {
      href: "https://undiksha.ac.id/akademik/fakultas/fakultas-kedokteran/profesi-bidan/",
      text: "Profesi - Pendidikan Profesi Bidan",
    },
  ];

  const filteredLinks = links.filter((link) =>
    link.text.toLowerCase().includes(filter.toLowerCase()),
  );

  return (
    <div>
      <div className="relative">
        <Input
          placeholder="Search..."
          value={filter}
          onChange={(event) => setFilter(event.target.value)}
          className="pl-10"
        />
        <div className="absolute top-1/2 -translate-y-1/2 left-3">
          <LuSearch />
        </div>
      </div>
      <div className="mt-3 h-[20rem] overflow-auto flex flex-col gap-y-1">
        {filteredLinks.map((link, index) => (
          <div
            key={index}
            className="py-2 px-3 rounded-full hover:bg-secondary flex items-center gap-3"
          >
            <LuChevronRight size={10} />
            <a href={link.href} target="_blank" rel="noopener noreferrer">
              {link.text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListProdi;
